import React from "react";
import taxi from "../Images/peter-kasprzyk-111462-unsplash.jpg";
import tour from "../Images/janis-oppliger-178385-unsplash.jpg";
import hotel from "../Images/eunice-stahl-572017-unsplash.jpg";
import { Link } from "react-router-dom";

export default function AddServices() {
  return (
    <div>
      <div className="container">
        <div className="row my-4">
          <div className="mountain-parallax parallax d-flex justify-content-center align-items-center col-12">
            <h1 className="main-photo-text">Additional services</h1>
          </div>
        </div>

        <div className="row">
          <div className="card col-12">
            <div className="row">
              <Link className="col-12 row full-card-div div-zoom" to="/additional-features/airport-pick-up">
                <div className="col-12 col-md-5">
                  <div className='img-hover-zoom mt-4'>
                  <img
                    src={taxi}
                    alt="taxi"
                    className="card-img img-fluid add-photo "
                  />

                  </div>
                </div>

                <div className="card-body col-12 col-md-4 d-flex flex-column justify-content-center">
                  <div className="card-title">
                    <h5>Pick-up from airport</h5>
                  </div>
                  <div className="card-text">
                    <p className="text-justify">
                      Tell us when your's plane is arriving and we will pick you
                      up from the airport to your hotel
                    </p>
                  </div>
                  <Link
                    to="/additional-features/airport-pick-up"
                    className="card-link mx-auto stretched-link"
                  >
                    More info
                  </Link>
                </div>
              </Link>
              <Link className="col-12 row full-card-div div-zoom" to="/additional-features/more-tours">
                <div className="col-12 col-md-5">
                  <div className='img-hover-zoom mt-4'>

                  <img
                    src={tour}
                    alt="tour"
                    className="card-img img-fluid add-photo "
                  />
                  </div>
                </div>

                <div className="card-body  col-12 col-md-4 d-flex flex-column justify-content-center">
                  <div className="card-title">
                    <h5>More tours</h5>
                  </div>
                  <div className="card-text">
                    <p className="text-justify">
                      If you want to discover everything about a place where you
                      are going - pick up those additional premium tours!
                    </p>
                  </div>
                  <Link
                    to="/additional-features/more-tours"
                    className="card-link mx-auto"
                  >
                    More info
                  </Link>
                </div>
              </Link>
              <Link className="col-12 row full-card-div div-zoom mb-4" to="/additional-features/hotels">
                <div className="col-12 col-md-5">
                  
                <div className='img-hover-zoom mt-4'>
                  <img
                    src={hotel}
                    alt="hotel"
                    className="card-img img-fluid add-photo "
                  />
                  </div>
                </div>

                <div className="card-body col-12 col-md-4 d-flex flex-column justify-content-center">
                  <div className="card-title">
                    <h5>Better hotel</h5>
                  </div>
                  <div className="card-text">
                    <p className="text-justify">
                      If you want to stay in hotel that is closer to the sea or
                      mountain's just let us know!
                    </p>
                  </div>
                  <Link
                    to="/additional-features/hotels"
                    className="card-link mx-auto"
                  >
                    More info
                  </Link>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
